var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styles from './card.module.css';
import clsx from 'clsx';
export var Card = function (_a) {
    var children = _a.children, _b = _a.component, component = _b === void 0 ? 'div' : _b, _c = _a.variant, variant = _c === void 0 ? 'default' : _c, _d = _a.shadow, shadow = _d === void 0 ? 'low' : _d, _e = _a.noMargin, noMargin = _e === void 0 ? false : _e;
    var RootElement = component;
    return (_jsx(RootElement, __assign({ className: clsx(styles.card, variant === 'outlined' && styles.card__outlined, shadow === 'none' && styles.card__shadow__none, shadow === 'low' && styles.card__shadow__low, shadow === 'mid' && styles.card__shadow__mid, shadow === 'high' && styles.card__shadow__high, noMargin && styles.card__noMargin) }, { children: children })));
};
export default Card;
